const SDK_VERSION = '7.30.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
